import React, { useEffect, useState } from 'react'
import AuthChoice from './AuthChoice'
import Login from './Login'
import Register from './Register'
import VerifyRegistration from './VerifyRegistration'
import PlanSelection from './PlanSelection'
import PaymentMethod from './PaymentMethod'
import PaymentProcessing from './PaymentProcessing'

const AuthFlow = ({ onAuthSuccess, goRenew, cancleRenew }) => {
  const [flow, setFlow] = useState('choice') // choice, login, register, verify, plan, payment, processing
  const [registerData, setRegisterData] = useState(null)
  const [selectedPlan, setSelectedPlan] = useState(null)
  const [paymentData, setPaymentData] = useState(null)
  const [renewSubscriptionData, setRenewSubscriptionData] = useState({})

  const handleChooseLogin = () => {
    setFlow('login')
    // on actualise la page si l'user souhaite retourner au login alors qu'il était sur un renouvellement
    if (goRenew?.renewSubscription) {
      window.location.reload()
    }
  }

  const handleChooseRegister = () => {
    setFlow('register')
  }

  const handleBackToChoice = () => {
    setFlow('choice')
    setRegisterData(null)
    setSelectedPlan(null)
    setPaymentData(null)
  }

  const handleLoginSuccess = (data) => {
    onAuthSuccess(data)
  }

  const handleRegisterDataReady = (data) => {
    setRegisterData(data)
    setFlow('verify')
  }

  const handleVerificationSuccess = (value) => {
    if (value?.renewSubscription) {
      setRenewSubscriptionData(value)
    }
    setFlow('plan')
  }

  const handlePlanSelected = (plan) => {
    setSelectedPlan(plan)
    setFlow('payment')
  }

  const handlePaymentInitiated = (payment) => {
    setPaymentData(payment)
    setFlow('processing')
  }

  // const handlePaymentSuccess = (data) => {
  //   onAuthSuccess(data)
  // }

  const handlePaymentFailed = () => {
    setFlow('payment')
    setPaymentData(null)
  }

  useEffect(() => {
    // action de renouvellement depuis la page de settings
    if (goRenew?.renewSubscription) {
      handleVerificationSuccess(goRenew)
    }
  }, [goRenew])

  return (
    <>
      {flow === 'choice' && (
        <AuthChoice
          onChooseLogin={handleChooseLogin}
          onChooseRegister={handleChooseRegister}
        />
      )}

      {flow === 'login' && (
        <Login
          onBack={handleBackToChoice}
          onLoginSuccess={handleLoginSuccess}
          isRenewSubscription={handleVerificationSuccess}
        />
      )}

      {flow === 'register' && (
        <Register
          onBack={handleBackToChoice}
          onRegisterDataReady={handleRegisterDataReady}
        />
      )}

      {flow === 'verify' && (
        <VerifyRegistration
          onBack={() => setFlow('register')}
          registerData={registerData}
          onVerificationSuccess={handleVerificationSuccess}
        />
      )}

      {flow === 'plan' && (
        <PlanSelection
          registerData={registerData}
          onPlanSelected={handlePlanSelected}
          onSuccessFreeRegister={handleChooseLogin}
          renewSubscriptionData={renewSubscriptionData}
          goBack={(flowFrom) => {
            flowFrom === 'login'
              ? setFlow('login') && cancleRenew({})
              : cancleRenew({})
          }}
          onLoginSuccess={handleLoginSuccess}
        />
      )}

      {flow === 'payment' && (
        <PaymentMethod
          onBack={() => {
            setFlow('plan')
          }}
          selectedPlan={selectedPlan}
          registerData={registerData}
          renewSubscriptionData={renewSubscriptionData}
          onPaymentInitiated={handlePaymentInitiated}
        />
      )}

      {flow === 'processing' && (
        <PaymentProcessing
          paymentData={paymentData}
          // onPaymentSuccess={handlePaymentSuccess}
          onPaymentSuccessRedirectForLogin={handleChooseLogin}
          onPaymentFailed={handlePaymentFailed}
          onLoginSuccess={handleLoginSuccess}
        />
      )}
    </>
  )
}

export default AuthFlow
